import React from 'react';

interface QuotaMeterProps {
  used: number;
  limit: number;
  tier: string;
}

export default function QuotaMeter({ used, limit, tier }: QuotaMeterProps) {
  const percentage = (used / limit) * 100;
  const remaining = limit - used;

  const getColorClass = () => {
    if (percentage < 70) return 'bg-green-500';
    if (percentage < 90) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  const getStatusText = () => {
    if (percentage < 70) return 'Good';
    if (percentage < 90) return 'Warning';
    return 'Critical';
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg font-semibold text-gray-900">Report Quota</h3>
        <span className="text-sm font-medium text-gray-500 uppercase">{tier} Plan</span>
      </div>
      
      <div className="flex justify-between items-center mb-3">
        <span className="text-2xl font-bold text-gray-900">{used} / {limit}</span>
        <span className={`text-sm font-semibold ${
          percentage < 70 ? 'text-green-600' : percentage < 90 ? 'text-yellow-600' : 'text-red-600'
        }`}>
          {getStatusText()}
        </span>
      </div>
      
      <div className="w-full bg-gray-200 rounded-full h-4 mb-3">
        <div
          className={`h-4 rounded-full transition-all duration-500 ${getColorClass()}`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      
      <div className="flex justify-between text-sm text-gray-600">
        <span>{remaining} reports remaining</span>
        <span>{percentage.toFixed(0)}% used</span>
      </div>
      
      {percentage >= 90 && (
        <div className="mt-4 bg-red-50 border border-red-200 rounded-lg p-3">
          <p className="text-sm text-red-800 font-medium">⚠️ Quota almost exhausted. Consider upgrading your plan.</p>
        </div>
      )}
    </div>
  );
}
